import { BaseComponentProps, useComponentData } from '../helpers/contentHooks';
import { ClickableComponentLayout } from '../layouts/ClickableComponentLayout';
import { Content } from '@wajeez-web/core/api-base';
import { useEffect, useState } from 'react';

export interface SubCategoryListParameters {
  title: string | null;
}

export interface SubCategoryProps extends BaseComponentProps {
  onSelect?: (item: Content.ContentEntityOutput) => void;
  subCategoryQuery?: string | undefined;
  contents?: Content.ContentEntityOutput[];
}

export function SubCategoryList({
  component,
  context,
  onSelect,
  subCategoryQuery,
  contents,
}: SubCategoryProps) {
  const [selectedItem, setSelectedItem] = useState<string | undefined>(
    subCategoryQuery
  );

  const list =
    context && contents
      ? [
          {
            ...context,
            title: 'الكل',
          },
          ...contents,
        ]
      : contents;

  useEffect(() => {
    const foundContext =
      selectedItem && list?.find((l) => l.id === selectedItem);

    if (onSelect) {
      if (foundContext) {
        setSelectedItem(foundContext.id);

        onSelect(foundContext);
      } else {
        setSelectedItem(context?.id);

        onSelect({
          ...context,
          title: 'الكل',
        });
      }
    }
  }, [selectedItem]);

  useEffect(() => {
    setSelectedItem(subCategoryQuery);
  }, [subCategoryQuery]);

  return (
    <div className="w-full sm:px-[36px]">
      <div className=" flex overflow-x-auto scrollbar-none px-2">
        <div className={`flex flex-nowrap flex-row  space-s-2 pb-[23px] px-2`}>
          {list?.map((content, i) => (
            <SubCategoryItem
              key={content.id}
              component={{ ...component?.itemTemplate, uniqueId: i }}
              context={content}
              onClick={() => setSelectedItem(content.id)}
              isSelected={selectedItem === content.id}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export interface SubCategoryItemProps extends BaseComponentProps {
  onClick: () => void;
  isSelected: boolean;
}

export interface SubCategoryItemParameters {
  image: string | null;
}

export const SubCategoryItem = ({
  component,
  context,
  onClick,
  isSelected,
}: SubCategoryItemProps) => {
  const { content } = useComponentData<SubCategoryItemParameters>(
    component,
    context
  );

  return (
    <ClickableComponentLayout content={content} onClick={onClick}>
      <div
        className={`px-[18px] pt-[12px] pb-[11px] rounded-[21px] text-[16px] w-max ${
          isSelected ? 'bg-[#38A7B4] text-white' : 'bg-[#F4F4F5] text-[#424242]'
        }`}
      >
        {content?.title}
      </div>
    </ClickableComponentLayout>
  );
};
